// extracted by mini-css-extract-plugin
export default {"button":"package-table_button__CIrUv","content":"package-table_content__PrZ9G"};